import { AmplitudeEventConstants } from '..'

enum CFECustomerType {
  LoanOfficers = 'loan-officers',
  InsuranceAgents = 'insurance-agents',
  RealEstateAgents = 'real-estate-agents',
}

enum ListingsBotCustomerType {
  LoanOfficers = 'LoanOfficer',
  InsuranceAgents = 'InsuranceAgent',
  RealEstateAgents = 'RealEstateAgent',
}

export const getAmplitudeCustomerType = (
  customerType: CFECustomerType | ListingsBotCustomerType
) => {
  if (
    customerType === CFECustomerType.LoanOfficers ||
    customerType === ListingsBotCustomerType.LoanOfficers
  ) {
    return AmplitudeEventConstants.CUSTOMER_TYPE_LO
  } else if (
    customerType === CFECustomerType.InsuranceAgents ||
    customerType === ListingsBotCustomerType.InsuranceAgents
  ) {
    return AmplitudeEventConstants.CUSTOMER_TYPE_IA
  } else {
    return AmplitudeEventConstants.CUSTOMER_TYPE_REA
  }
}
